<!-- #maintenance: some videos may be briefly unavailable (2026-10-23: on the shared dialog, from
     ModalDialog/Maintenance.vue). Nothing opens it at present: the watch that opened it once a
     visit on the video pages was commented out -->
<template>
  <AppModalDialog hash="maintenance">
    <AppFormWrapper>
      <h2>Page Under Maintenance</h2>
      <p>Some videos may be briefly unavailable due to maintenance.</p>
      <p>
        If you run into issues, try again later — currently, we expect things to be back to normal
        within 24 hours.
      </p>
    </AppFormWrapper>
    <template #footer>
      <ButtonBespoke outstanding @click="close">OK</ButtonBespoke>
    </template>
  </AppModalDialog>
</template>

<script setup>
import {useRouter} from "vue-router";
import AppModalDialog from "@/components/App/Modal/Dialog/index";
import AppFormWrapper from "@/components/App/Form/Wrapper";
import ButtonBespoke from "@/components/ButtonBespoke";

const router = useRouter();

function close() {
  sessionStorage.setItem("seenMaintenanceModal", "true");
  router.replace({hash: ""});
}
</script>
